module.exports = __webpack_public_path__ + "img/about_vision.0e25fdb7.png";